import { useGetProjectCustomFieldVariables } from '@/hooks/useProjectCustomFields';
import { automationDataAccessTypeReadableNameMap } from '@payaca/helpers/automationHelper';
import { AutomationDataAccessType } from '@payaca/types/automationDataAccessTypes';
import { AutomationEntityTypes } from '@payaca/types/automationTypes';
import { automationEntityTypeActionVariablesMap } from '@payaca/types/automationVariableTypes';
import { useMemo } from 'react';

export const useActionVariablesForAutomationEntityType = (
  automationEntityType: AutomationEntityTypes
) => {
  const projectCustomFieldVariables =
    useGetProjectCustomFieldVariables<AutomationDataAccessType>(
      'project.customField.value',
      automationDataAccessTypeReadableNameMap['project.customField.value'],
      ['user']
    );

  // TODO: Apply some additional filtering here - not all variables should be available on default automations
  const variables = useMemo(() => {
    const variableNames =
      automationEntityTypeActionVariablesMap[automationEntityType] || [];
    const variableReadableNameMap: Record<string, string> = {};

    variableNames.forEach((variable) => {
      variableReadableNameMap[variable] =
        automationDataAccessTypeReadableNameMap[variable];
    });

    if (variableNames.includes('project.customField.value')) {
      projectCustomFieldVariables.forEach((variable) => {
        // @ts-expect-error
        variableNames.push(variable.variableName);
        variableReadableNameMap[variable.variableName] = variable.displayName;
      });
    }

    return { variableNames, variableReadableNameMap };
  // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useMemo has a missing dependency: 'automationEntityType'
  }, [projectCustomFieldVariables]);

  return {
    variables: variables.variableNames,
    variableReadableNameMap: variables.variableReadableNameMap,
  };
};
